export default __webpack_public_path__ + "static/media/icon-reload-color-primary.1169dc08.svg";